import { Modal, SelectInput } from "@risalabs_frontend_org/oasis-ui-kit";
import { HistoricNarClearReason } from "../../../../../api/services/historicNar/types";
import { ModalId } from "../../../../../enums/modalId";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";
import useNeedsReview from "../hooks/useNeedsReview";

/** Select options that preserve the backend reason values. */
export const NEEDS_REVIEW_REASON_OPTIONS = Object.values(
  HistoricNarClearReason,
).map((reason) => ({
  label: capitalizeWordsSeperatedByUnderScore(reason),
  value: reason,
}));

interface NeedsReviewModalProps {
  identifier?: string;
  onClose: () => void;
  onReIngest: () => void;
}

/** Review-state actions before reopening the recommendation ingest form. */
const NeedsReviewModal = ({
  identifier,
  onClose,
  onReIngest,
}: NeedsReviewModalProps) => {
  const {
    isSubmitting,
    disableActions,
    saveButtonText,
    cancelText,
    handleReasonChange,
    handleSave,
    handleReIngest,
  } = useNeedsReview({ identifier, onClose, onReIngest });

  // Oasis closes before invoking onCancel by default. The hook closes only after
  // the clear-lane request succeeds, preventing unmount cleanup from aborting it.
  return (
    <Modal
      dialogId={ModalId.NEEDS_REVIEW_MODAL}
      onSave={handleReIngest}
      onCancel={handleSave}
      title="Needs Review"
      saveButtonText={saveButtonText}
      cancelText={cancelText}
      onClose={onClose}
      disableSave={disableActions}
      disableCancel={disableActions}
      disableOnCloseFunc
      disableCloseOnOutsideClick={isSubmitting}
      maxHeightPercentage={50}
    >
      <SelectInput
        options={NEEDS_REVIEW_REASON_OPTIONS}
        label="Review Reason"
        placeholder="Select a reason"
        onChange={handleReasonChange}
      />
    </Modal>
  );
};

export default NeedsReviewModal;
